<template>
  <div>
    <v-container class="pt-0">
      <span class="headline">{{$tenant.tenant === 'bfv' ? $t('shop.title-bfv') : $t('shop.title')}}</span>
      <v-row>
        <v-col cols="12">
          <coin-balance/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          {{ $t("shop.description") }}
        </v-col>
        <v-col cols="12" v-for="product in products" :key="product.sku">
          <v-btn :class="product.available == true ? 'primary' : ''" :disabled="loading"
            @click="openPurchaseProduct(product)"
            style="text-transform:inherit;"
          >
            <v-icon left>{{product.mdiIcon}}</v-icon>
            {{product.name}} für {{product.coinPrice}}<v-icon right>mdi-circle-multiple-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <advertising-content :only="['adspirit']"/>
        </v-col>
      </v-row>
    </v-container>
    <purchase-dialog
        v-if="purchaseProduct"
        :title="purchaseProduct.name"
        :visible="true"
        :loading="loading"
        :sku="purchaseProduct.sku"
        :description="purchaseProduct.description"
        :price="purchaseProduct.coinPrice"
        :available="purchaseProduct.available"
        :confirmAction="purchaseProductConfirmed"
        :closeAction="cancelPurchaseProduct"
      />
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import {MUTATION_RAISE_NOTIFICATION, ACTION_LOAD_COIN_ACCOUNT} from "@/plugins/store"
import CoinBalance from "@/widgets/CoinBalance";
import PurchaseDialog from "@/widgets/PurchaseDialog";
import AdvertisingContent from '../widgets/AdvertisingContent.vue';

export default {
  name: "Shop",
  components: {CoinBalance, PurchaseDialog, AdvertisingContent},

  data: () => ({
    loading: false,
    products: undefined,
    purchaseProduct: undefined,
  }),
  mounted() {
    this.loadProducts();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    onRefreshData() {
      this.loadProducts()
    },
    loadProducts() {
      this.loading = true;
      this.$api
        .getShopProducts()
        .then((response) => {
          this.loading = false;
          this.products = response.data.list;
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    purchaseProductConfirmed(sku) {
      console.log('purchaseProduct', sku)
      this.loading = true;
      this.$api.purchaseShopProduct(sku)
        .then((response) => {
          this.purchaseProduct = null;
          this.$store.dispatch(ACTION_LOAD_COIN_ACCOUNT)
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: response.data.message
          });
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    openPurchaseProduct(product) {
      this.purchaseProduct = product;
    },
    cancelPurchaseProduct() {
      this.purchaseProduct = null;
    }
  },
};
</script>
